import styled from '@emotion/styled';

export const Icons = styled.div`
  unicode-bidi: bidi-override;
  position: relative;
  font-size: 16px;
  padding: 0;
`;

export const Empty = styled.div`
  color: #c3c5ca;
  display: block;
  z-index: 0;
`;

export const Filled = styled.div`
  color: #ffd05b;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  height: inherit;
  white-space: nowrap;
`;
